import { useState, useEffect } from 'react';
import { Container, TextField, DialogActions, Button, Alert, Pagination, Grid, InputAdornment } from "@mui/material";
import AddIcon from '@mui/icons-material/Add';
import toast from 'react-hot-toast';
import Page from "../components/Page";
import Loader from "./Loader";
import { UsersTable, UserPopup } from '../components/userManagement';
import Popup from '../components/Popup';
import Controls from '../components/controls/Controls';
import { getUsersList, createUser, updateUser, deleteUser } from '../config/services/users';
import { getAllRolesName } from '../config/services/role';
import SearchIcon from '../assets/icons/icon_search.svg';
import _ from 'lodash';
import { isValidEmail } from '../utils/Reusables';


export default function UserType() {
    const [openPopup, setOpenPopup] = useState(false);
    const [userTypeList, setUserTypeList] = useState([]);
    const [recordForEdit, setRecordForEdit] = useState({})
    const [userTypeTotalCount, setUserTypeListCount] = useState(0)
    const [search, setSearchValue] = useState('')
    const [sortObj, setSortObj] = useState({ sortKey: 'createdAt', sortOrder: '-1' })
    const [loader, setLoading] = useState(false)
    const [pageNo, setPagination] = useState(1)
    const [itemsPerPage, setItemsPerPage] = useState(10)
    const [deleteObj, setDeleteObj] = useState({})
    const [deletePopup, setDeletePopup] = useState(false)
    const [rolesList, setRolesList] = useState([])

    const fetchRolesList = () => {
        getAllRolesName()
            .then(res => {
                if (res?.result)
                    setRolesList(res?.result)
                else
                    console.error(res)
            })
    }

    const validateAddUser = (filledDetails) => {
        let { firstName, lastName, roleDetails, s_uuid, password, _id, email } = filledDetails

        if (!firstName) {
            toast.error('Fill First Name')
            return false
        }
        else if (!lastName) {
            toast.error('Fill Last Name')
            return false
        }
        else if (!s_uuid) {
            toast.error('Fill Employee Code')
            return false
        }
        else if (email && !isValidEmail(email)) {
            toast.error('Enter Valid Email.')
            return false
        }
        else if (!password && !_id) {
            toast.error('Fill Password')
            return false
        }
        else if (!roleDetails) {
            toast.error('Select Role')
            return false
        }
        else {
            return true
        }
    }

    const addOrEdit = () => {
        if (validateAddUser(recordForEdit)) {
            let paramsObj = {
                ...recordForEdit,
                roleId: recordForEdit?.roleDetails._id
            }

            if (recordForEdit?.schoolCodes && Array.isArray(recordForEdit?.schoolCodes)) {
                paramsObj.schoolCodes = recordForEdit?.schoolCodes
            }
            else if (recordForEdit?.schoolCodes) {
                paramsObj.schoolCodes = recordForEdit?.schoolCodes?.split(',')?.map(itm => itm?.trim())
            }

            if (paramsObj?._id) {
                paramsObj.userId = paramsObj?._id
                updateUser(paramsObj)
                    .then(res => {
                        if (res?.result) {
                            handleCloseEditPopup()
                            fetchUserTypeList()
                            toast.success(res?.message)
                        }
                        else if (res?.data?.statusCode === 0) {
                            let { errorMessage } = res?.data?.error
                            toast.error(errorMessage)
                        }
                        else {
                            console.error(res);
                        }
                    })

            }
            else {
                createUser(paramsObj)
                    .then(res => {
                        if (res?.result) {
                            handleCloseEditPopup()
                            fetchUserTypeList()
                            toast.success(res?.message)
                        }
                        else if (res?.data?.statusCode === 0) {
                            let { errorMessage } = res?.data?.error
                            toast.error(errorMessage)
                        }
                        else {
                            console.error(res);
                        }
                    })
            }
        }
    }

    const handleOnChange = (e) => {
        let { value, name } = e.target
        let filledDetails = _.cloneDeep(recordForEdit)
        filledDetails[name] = value
        setRecordForEdit(filledDetails)
    }


    const handleSelectRole = (e, newSelectValue) => {
        let filledDetails = _.cloneDeep(recordForEdit)
        filledDetails.roleDetails = newSelectValue
        setRecordForEdit(filledDetails)
    }

    const handleCloseEditPopup = () => {
        setOpenPopup(false);
        setRecordForEdit({})
    }

    let totalPages = Number((userTypeTotalCount / itemsPerPage).toFixed(0))
    if ((totalPages * itemsPerPage) < userTypeTotalCount)
        totalPages = totalPages + 1;

    const fetchUserTypeList = () => {
        let params = { pageNo: (pageNo - 1), count: itemsPerPage, search, ...sortObj }
        setLoading(true)
        getUsersList(params)
            .then((res) => {
                setUserTypeList(res?.result);
                setUserTypeListCount(res?.totalCount)
                setLoading(false)
            });
    }

    const openInPopup = userTypeEdit => {
        userTypeEdit.roleDetails = rolesList?.find(itm => itm._id === userTypeEdit.roleId)
        setRecordForEdit(userTypeEdit)
        setOpenPopup(true)
    }

    useEffect(() => fetchRolesList(), [])

    const deleteUserTypeF = params => {
        setDeleteObj({ userId: params?._id, firstName: params?.firstName, lastName: params?.lastName })
        setDeletePopup(true)
    }

    const submitDeleteUserType = () => {
        let { userId } = deleteObj
        deleteUser({ userId })
            .then(res => {
                if (res?.result) {
                    handleCancelDelete()
                    fetchUserTypeList()
                    toast.success(res?.message)
                }
                else if (res?.data?.statusCode === 0) {
                    let { errorMessage } = res?.data?.error
                    toast.error(errorMessage)
                }
                else {
                    console.error(res);
                }
            })
    }

    const handlePagination = (e, pageNumber) => {
        setPagination(pageNumber)
    }

    const handleSearch = (e) => {
        let { value } = e.target
        setPagination(1)
        setSearchValue(value, () => setPagination(1))
    }


    const handleCancelDelete = () => {
        setDeletePopup(false)
        setDeleteObj({})
    }

    const handleAddUser = () => {
        fetchRolesList()
        setOpenPopup(true);
        setRecordForEdit({});
    }

    useEffect(() => fetchUserTypeList(), [search, sortObj, pageNo, itemsPerPage]);

    return (
        <>
            <Page title="Extramarks | User Management" className="main-container datasets_container">
                <Container className='table_max_width'>
                    <Grid container alignItems="left" justifyContent="flex-start" mb={2} spacing={2.5} >
                        <Grid item xs={12} sm={6} md={6} lg={6} className="datasets_header" >
                            <TextField className={`inputRounded search-input`} type="search"
                                placeholder="Search By User's Name"
                                onChange={handleSearch}
                                InputLabelProps={{ style: { ...({ top: `${-7}px` }) } }}
                                InputProps={{
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <img src={SearchIcon} />
                                        </InputAdornment>
                                    ),
                                }}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6} md={6} lg={6} >
                            <Grid container justifyContent="flex-end" spacing={2.5}>
                                <Grid item xs={6} sm={6} md={6} lg={4} display="flex" justifyContent="flex-end" >
                                    <Controls.Button
                                        text="New User"
                                        variant="contained"
                                        startIcon={<AddIcon />}
                                        className="cm_ui_button"
                                        onClick={() => handleAddUser()}
                                    />
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>


                    {loader && <Loader />}
                    {userTypeList?.length ? <UsersTable list={userTypeList} openInPopup={openInPopup} deleteUserType={deleteUserTypeF} pageNo={pageNo} itemsPerPage={itemsPerPage} /> :
                        <Alert severity="error">No Content Available!</Alert>}
                </Container>

                <div className='center cm_pagination'>
                    <Pagination count={totalPages} variant="outlined" color="primary" onChange={handlePagination} page={pageNo} />
                </div>
            </Page>


            <UserPopup handleSelectRole={handleSelectRole}
                rolesList={rolesList} handleOnChange={handleOnChange} openPopup={openPopup}
                recordForEdit={recordForEdit} addOrEdit={addOrEdit}
                handleCloseEditPopup={handleCloseEditPopup} />

            <Popup title={`Are you sure to delete "${deleteObj?.firstName} ${deleteObj?.lastName}" ?`} openPopup={deletePopup} setOpenPopup={handleCancelDelete} onClose={false}>
                <DialogActions>
                    <Button onClick={handleCancelDelete} color="primary">Cancel</Button>
                    <Button onClick={submitDeleteUserType} color="error" autoFocus>Delete</Button>
                </DialogActions>
            </Popup>
        </>
    )
}
